import { z } from "zod/v4";

type UpsellProductRulesNodeLike = {
  query?: {
    type: string;
    value?: unknown;
  };
};

type UpsellProductRulesActionLike = {
  expression: UpsellProductRulesNodeLike[];
};

type UpsellProductRulesLike = {
  action: UpsellProductRulesActionLike;
};

export const upsellProductRulesRefinements = {
  expressionQueriesHaveTypeOrValue: <T extends UpsellProductRulesLike>(
    rule: T
  ) => {
    return rule.action.expression.every((node) => {
      if (!node.query) {
        return true;
      }
      return (
        node.query.type === "shopifyRecommendations" ||
        node.query.value !== undefined
      );
    });
  },
};

export const upsellProductRulesRefinementMessages = {
  expressionQueriesHaveTypeOrValue:
    "Upsell product rules expression queries must have 'shopifyRecommendations' type or a value",
};

export function applyUpsellProductRulesRefinements<
  S extends z.ZodType<UpsellProductRulesLike>,
>(schema: S) {
  return schema.refine(
    (rule) =>
      upsellProductRulesRefinements.expressionQueriesHaveTypeOrValue(
        rule as UpsellProductRulesLike
      ),
    {
      error:
        upsellProductRulesRefinementMessages.expressionQueriesHaveTypeOrValue,
    }
  );
}
